import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../app.config';
import { AppConfig } from '../../models/config/app-config';


export type ButtonName = 'cancel' | 'load' | 'save' | 'complete';

@Component({
  selector: 'app-button-bar',
  templateUrl: './button-bar.component.html',
  styleUrls: ['./button-bar.component.scss']
})
export class ButtonBarComponent {

  @Input()
  validities: any;

  /**
   * Disable all buttons to prevent abuse
   */
  @Input()
  disableButtons: boolean = false;

  @Input()
  formValid: Observable<boolean>;

  @Output()
  antragReset = new EventEmitter<void>();

  @Output()
  antragSaved = new EventEmitter<void>();

  @Output()
  antragCompleted = new EventEmitter<void>();

  @ViewChild('neuerAntrag', { static: true })
  neuerAntrag: ElementRef;


  @ViewChild('fehlerAntrag', { static: true })
  fehlerAntrag: ElementRef;


  constructor(private modalService: NgbModal,
              @Inject(APP_CONFIG) protected appConfig: AppConfig) {
  }

  buttonchanger: string = this.appConfig.umgebung;

  async onNeuerAntragClicked() {
    await this.modalService.open(this.neuerAntrag).result.then(
      (result) => {
        if (result === 'ok') {
          this.antragReset.emit();
        }
      }
    );
  }

  onButtonClicked(buttonName: string): void {
    switch (buttonName) {
      case 'back':
        //navigate to startseite
        window.location.href = location.origin;
        break;
      case 'reset':
        this.onNeuerAntragClicked();
        break;
      case 'save':
        this.antragSaved.emit();
        break;
      case 'complete':
        this.antragCompleted.emit();
        break;
      case 'fehler':
        this.modalService.open(this.fehlerAntrag);
        break;
      default:
        throw new Error('unknown button name: ' + buttonName);
    }
  }

  isValid(formName: string): boolean {
    return !(this.validities && this.validities[formName] && this.validities[formName].valid === false);
  }

  isFormValid() {
    const filtered = Object.keys(this.validities)
    .filter(area => this.validities[area] && this.validities[area].valid === false);
    return filtered.length === 0;
  }


}
